import script from "./FollowerListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FollowerListModal.vue?vue&type=script&setup=true&lang=ts"

import "./FollowerListModal.vue?vue&type=style&index=0&id=01b808c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01b808c4"]])

export default __exports__